import { render, staticRenderFns } from "./new-user-coupon.vue?vue&type=template&id=29b6a2a6&scoped=true&"
import script from "./new-user-coupon.vue?vue&type=script&lang=js&"
export * from "./new-user-coupon.vue?vue&type=script&lang=js&"
import style0 from "./new-user-coupon.vue?vue&type=style&index=0&id=29b6a2a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b6a2a6",
  null
  
)

export default component.exports